import { EditorSection } from '../EditorSection';
import { usePlotEditorContext } from '../PlotEditorContext';
import { LayoutControls } from '../layout-controls';

/**
 * Layout & Subplots Tab
 * Primary: Figure size, backgrounds
 * Advanced: Margins, facets, preview zoom
 */
export function LayoutSubplotsTab() {
  const { plotlyJson, onUpdate } = usePlotEditorContext();

  return (
    <div className="space-y-4">
      {/* Section heading */}
      <div className="space-y-1">
        <h3 className="text-xs font-semibold text-foreground">Layout & Subplots</h3>
        <p className="text-[11px] text-muted-foreground">
          Control figure size, margins, backgrounds, and subplot layout.
        </p>
      </div>

      {/* Figure Size */}
      <div className="space-y-2">
        <p className="text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
          Figure Size
        </p>
        <LayoutControls plotlyJson={plotlyJson} onUpdate={onUpdate} />
      </div>

      {/* TODO: Add facets group */}
    </div>
  );
}

